<template>
<div class="navbar-container">
    <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="container">
            <div class="navbar-brand">
                <a class="navbar-item" href="" v-scroll-to="'#cover'">
                    <img src="../../public/image/108hill-logo-revised.png">
                    <!-- <div class="custom-logo">
                        <p>108Hill</p>
                        <p>Office &amp; Residence</p>
                    </div> -->
                </a>
                <a role="button"
                    v-on:click="toggleMenu()"
                    :class="[isActive ? activeClass : '', burgurNav]"
                    aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>

            <div id="navbarBasicExample" :class="[isActive ? activeClass : '', menuNav]">
                <div class="navbar-start"></div>

                <div class="navbar-end">
                    <a href="" class="navbar-item" v-scroll-to="'#residence'">
                        Residence Services
                    </a>
                    <a href="" class="navbar-item" v-scroll-to="'#office'">
                        Office Space
                    </a>
                    <a href="" class="navbar-item" v-scroll-to="'#meeting'">
                        Conference Room
                    </a>
                    <a href="" class="navbar-item" v-scroll-to="'#contact'">
                        Contact Us
                    </a>
                    <a href="https://form.jotform.me/91418497383468" class="navbar-item" target="blank">
                        Pricing
                    </a>
                </div>
            </div>
        </div>
        
    </nav>
</div>

</template>

<script>

export default {
    data() {
        return {
            isActive: false,
            activeClass: 'is-active',
            burgurNav: 'navbar-burger burger',
            menuNav: 'navbar-menu'
        }
    },
    methods:{
        toggleMenu(){
            this.isActive = !this.isActive;
            console.log(this.activeNav)
        }
    }
}

</script>

<style lang="scss" scoped>
.navbar-container{
    top: 0;
    position: fixed;
    width: 100%;
    z-index: 999;
    .navbar{
        background-color: $color-main;
        .burger{
            color: #fff;
        }
        .navbar-item{
            padding: 0 20px;
            color: #fff;
            font-weight: normal;
            font-size: 15px;
            &:hover{
                background-color: $color-sub;
            }
            @include mobile{
                padding: 10px 20px;
            }
            img{
                max-height: 45px;
            }
        }
        .navbar-menu{
            background-color: $color-main;
            @include mobile{
                padding: 0;
            }
        }
    }
    .custom-logo{
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        p{
            display: block;
            margin-left: 10px;
            line-height: 1.2;
            font-size: 12px;
            &:first-child{
                font-size: 16px;
                font-weight: 600;
            }
        }
    }
}
</style>